<template>
	<b-modal
		id="revokerequest"
		modal-class="bottom-modal"
		hide-footer
		hide-header
		no-close-on-backdrop
		class="p-0"
		:centered="isLaptop"
		v-model="showRevokeRequest"
		@hidden="$emit('close-modal')"
	>
		<div class="w100">
			<div
				class="d-flex align-items-center justify-content-between mb-2 w-100 p-3"
			>
				<div class="setup-job-pref-head mobmt20">Request Re-Activation</div>
				<img
					@click="$emit('close-modal')"
					class="rotate-on-hover pointer"
					src="@/assets/newdesign/dashboard/blueCross.svg"
					alt
				/>
			</div>
			<hr
				style="border-top: 1px solid rgb(153 157 163)"
				class="my-0"
				id="hideinmobile"
			/>
			<div class="p-3">
				<div class="position-relative">
					<label class="teams-label-font w-40">
						Reason
						<span class="asterik">*</span>
					</label>
					<SelectCustom
						:noLabel="true"
						placeholder="Select"
						:values="reasonOptions"
						:dropdown="true"
						:vmodel="$v.revokeObj.title.$model"
						:showError="$v.revokeObj.title.$error"
						@select-value="$v.revokeObj.title.$model = $event"
					/>
					<div
						v-if="$v.revokeObj.title.$error"
						class="candash-errortxt errortxt-pos"
					>
						Required
					</div>
				</div>

				<div class="position-relative mt-3">
					<label class="teams-label-font w-40">
						Remarks
						<span class="asterik">*</span>
					</label>
					<Textarea
						placeholder="Enter"
						:noLabel="true"
						:v-model="$v.revokeObj.remarks.$model"
						:showError="$v.revokeObj.remarks.$error"
						:limit="256"
						@select-value="$v.revokeObj.remarks.$model = $event"
						type="text"
						:mandatory="true"
					/>
					<div
						v-if="$v.revokeObj.remarks.$error"
						class="candash-errortxt errortxt-pos"
					>
						{{
							$v.revokeObj.remarks.$dirty && !$v.revokeObj.remarks.required
								? "Required"
								: "Max char length exceeded"
						}}
					</div>
				</div>
			</div>
		</div>

		<hr style="border-top: 1px solid rgb(153 157 163)" class="mb-0 mt-2" />

		<div class="p-3 w-100 d-flex justify-content-end gap-2">
			<div>
				<b-button
					class="candash-cancelBtn pointer"
					@click="$emit('close-modal')"
					>Cancel</b-button
				>
			</div>
			<div class="position-relative">
				<b-button
					class="candash-addBtn"
					:class="!LoaderStatus ? 'pointer' : 'opac-5'"
					@click="!LoaderStatus ? revokeSuspended() : ''"
				>
					<span :class="LoaderStatus ? 'invisible' : 'pointer'">Confirm</span>
				</b-button>
				<div v-if="LoaderStatus" class="loader-pos-new">
					<Loader />
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import Textarea from "@/components/InputComponents/Textarea.vue";
import SelectCustom from "@/components/InputComponents/SelectCustom.vue";
import Loader from "@/components/fixedcomponents/Loader.vue";
import { appealRequest } from "@/utils/apiFunctions";
import toast from "@/components/mixin/toast";

export default {
	name: "RevokeRequest",
	props: {
		showRevokeRequest: Boolean,
		isLaptop: Boolean,
	},
	mixins: [toast],
	data() {
		return {
			LoaderStatus: false,
			revokeObj: {
				title: null,
				remarks: null,
			},
			reasonOptions: [
				{
					key: "internet connectivity issues",
					label: "Internet Connectivity Issues",
				},
				{
					key: "power outage",
					label: "Power Outage During Scheduled Interview",
				},
				{
					key: "device not functioning",
					label: "Video/Audio Device Not Functioning Properly",
				},
				{
					key: "platform login_issues",
					label: "Platform Login/Access Issues",
				},
				{
					key: "tool or software_glitch",
					label: "Interview Tool or Scheduling Software Glitch",
				},
				{
					key: "medical emergency",
					label: "Medical Emergency",
				},
				{
					key: "travel or commute_delays",
					label: "Travel or Unforeseen Commute Delays",
				},
				{
					key: "time zone confusion",
					label: "Time Zone Confusion",
				},
				{
					key: "others",
					label: "Others",
				},
			],
		};
	},
	components: {
		Loader,
		Textarea,
		SelectCustom,
	},
	validations() {
		return {
			revokeObj: {
				title: {
					required,
				},
				remarks: {
					required,
					maxLength: maxLength(256),
				},
			},
		};
	},
	methods: {
		async revokeSuspended() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.LoaderStatus = true;
				try {
					const payload = this.revokeObj;
					console.log("the payload", payload);
					const res = await appealRequest(payload);
					if (res.status == 200) {
						this.successModal("Success", "Request sent successfully");
						this.$emit("request-submitted");
					}
				} catch (error) {
					console.log(error);
				} finally {
					this.LoaderStatus = false;
					this.$emit("close-modal");
					this.$v.$reset();
					this.revokeObj = {
						title: null,
						remarks: null,
					};
				}
			}
		},
	},
};
</script>

<style></style>
